<template>
    <div class="modal fade modal-style history-filter-modal" id="history-filter-modal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">{{$t('filters', 'Filter')}}</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">&#10006;</button>
                </div>
                <div class="modal-body">
                    <div class="filter-form-content">
                        <div class="wallet-filter-row">
                            <div class="input-field">
                                <label class="form-label">{{ $t('from','From')}}</label>
                                <input type="date" class="form-control" placeholder="30-05-23" aria-label="Username" id="exampleInputFrom" aria-describedby="addon-wrapping" v-model="formDates.fromDate">
                            </div>
                            <div class="input-field">
                                <label class="form-label">{{ $t('to','To')}}</label>
                                <input type="date" class="form-control" placeholder="30-05-23" aria-label="Username" id="exampleInputTo" aria-describedby="addon-wrapping" v-model="formDates.toDate">
                            </div>
                        </div>
                        <div class="input-field">
                            <label class="form-label">{{ $t('filter-by','Filter By')}}</label>
                            <div class="wallet-filter-radio">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value=""
                                    id='checkbox' v-model="allSelected" @click="selectAllOptions">
                                    <label class="form-check-label" for='checkbox'>
                                        {{$t('All', 'All')}}
                                    </label>
                                </div>
                                <div class="form-check" v-for="option in options" :key="option.lable">
                                    <input class="form-check-input" type="checkbox"
                                    :id="'checkbox-' + option.value" :value="option.value" v-model="option.selected">
                                    <label class="form-check-label" :for="'checkbox-' + option.value">
                                        {{ option.lable }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="header-but  info-footer">
                            <a href="javascript:void(0)" class="thm-but" @click="$emit('getWalletHistory')">{{$t('apply', 'Apply')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'WalletHistoryFilter',
    props:['options','selectedOptions','formDates'],
    emits:['getWalletHistory'],
    computed:{
        allSelected(){
            const selectedArray = [];
            this.options.forEach(opt => {
                if (opt.selected) {
                    selectedArray.push(opt);
                }
            })
            return selectedArray.length == this.options.length
        }
    },
    methods:{
        selectAllOptions(){
            this.options.forEach(opt => {
                if (!opt.selected) {
                    opt.selected = true;
                }
            })
        }
    }

}
</script>